@if (sidebarElement().guidelineAction || sidebarElement().guidelineCriteria) {
  <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
    @if (sidebarElement().guidelineAction) {
      <mat-tab label="{{ 'Action' | transloco }}">
        <div class="sidebar-content--detail-tab">
          <sidebar-action-tab
            [sidebarElement]="sidebarElement()"
            (flowchartElementDataChanged)="flowchartElementDataChanged.emit($event)" />
        </div>
      </mat-tab>
    }
    @if (sidebarElement().guidelineCriteria) {
      <mat-tab label="{{ 'Finding' | transloco }}">
        <div class="sidebar-content--detail-tab">
          <sidebar-finding-tab
            [sidebarElement]="sidebarElement()"
            (flowchartElementDataChanged)="flowchartElementDataChanged.emit($event)" />
        </div>
      </mat-tab>
    }

    @if (sidebarElement()?.guidelineAction?.activityDefinition || sidebarElement()?.guidelineCriteria?.findingDefinition) {
      <mat-tab label="{{ 'TechnicalInfo' | transloco }}">
        @if (sidebarElement()?.guidelineAction?.activityDefinition) {
          <sidebar-technical-info
            [guidelineComponent]="sidebarElement().guidelineAction.activityDefinition"
            [label]="'ActivityDefinition' | transloco" />
        }
        @if (sidebarElement()?.guidelineCriteria?.findingDefinition) {
          <sidebar-technical-info
            [guidelineComponent]="sidebarElement().guidelineCriteria.findingDefinition"
            [label]="'FindingDefinition' | transloco" />
        }
      </mat-tab>
    }
  </mat-tab-group>
}
